import script from "./ShopHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopHeader.vue?vue&type=script&lang=ts&setup=true"

import "./ShopHeader.vue?vue&type=style&index=0&id=2c49f748&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c49f748"]])

export default __exports__